import { useState } from 'react';
import type { ReportStudioState } from 'src/components/star-grid/hooks/useReportStudio';
export const useStudioDrop = (state: ReportStudioState) => {
  const [notice, setNotice] = useState('');
  const drop = (value: string, shelf: 'rows' | 'filters' | 'columns', compareWith?: string) => {
    let item: { kind?: string; id?: string };
    try {
      item = JSON.parse(value);
    } catch {
      setNotice('studioInvalidDrop');
      return;
    }
    if (item.kind === 'binding' && state.dataset.bindings.some((binding) => binding.id === item.id)) {
      if (shelf === 'columns') setNotice('studioColumnDropHelp');
      else state.addField(shelf, item.id!);
    } else if (item.kind === 'scenario' && state.template.catalog.scenarios.some((scenario) => scenario.id === item.id)) {
      if (shelf === 'columns') state.addScenario(item.id, compareWith);
      else setNotice('studioScenarioDropHelp');
    } else setNotice('studioInvalidDrop');
  };
  return { notice, dismiss: () => setNotice(''), drop };
};
